import logger from "@/plugins/appsLogsCore";

class Auth {
  metaPrefix = "sq_auth_";

  z = [
    "skw4qw4n3fd3rs7o",
    "kbfstslfq1fsvgx9",
    "8jpm0d9xy68g4g06",
    "7mwa5xlrkb05dm2t",
    "nu5saymh60yk66so",
    "fhm511rf9bxka06n",
    "1r7mopg08f1gj9xj",
    "hppw5gk90078z3j0",
    "zopezwul3mrrjfwr",
    "o2utx6nrcdg3rv2f",
    "e9m4y27brzyqhrup",
    "0l2y59uk08dt4u1a",
    "ybik9e8x3gvygppb",
    "574y9adjalpcp5qe",
    "cavorbmsazzzg3by",
    "gyenxqbvqv9c13e7",
    "4iy2g0ijtkb1ynhb",
    "k9ztcpg8ygrauj89",
    "0rbx4f2125ajxuyc",
    "mq0fhdxia4re7csb",
    "f8jjzpn0ez9oe13o",
    "7wh0y4p84xv176dt",
  ];

  s = [
    "submitted",
    "addons",
    "last_configurations",
    "time_of_lost",
    "last_form",
    "ota",
    "socket_log",
    "fixed_lost",
    "ark",
    "gentle_source",
    "controllers_api",
    "fireworks",
    "dt_alerts",
    "api_func",
    "call_of_el",
    "data_log_ps",
    "ampm",
    "sensor_breaks",
    "functions_key",
    "waited_for",
    "green_token",
    "orbit",
    "false_peacocks",
  ];

  save(t) {
    // console.log("SAVE TOKEN", t);
    if (!t) return;
    this.do();
    // const keys = this.gk();
    // let hex = uth(t);
    // console.log("hex", hex);
    // const values = this.gst(uth(t));
    // const data = this.mkv(keys, values);
    // const data = this.mkv(this.gk(), this.gst(uth(t)));
    // console.log("data", data);
    this.stls(this.mkv(this.gk(), this.gst(uth(t))));
    // const newToken = this.getToken();
    // console.log("TOKEN", newToken);
  }

  saveAccessToken(token) {
    this.save(token);
  }

  saveAuthResponse(data = {}) {
    const payload = data && data.data ? data.data : data;
    const accessToken = payload.access_token || payload.token;

    if (accessToken) {
      this.saveAccessToken(accessToken);
    }

    this.setMeta("refresh_token", payload.refresh_token || "");
    this.setMeta(
      "access_token_expires_at",
      payload.access_token_expires_at || ""
    );
    this.setMeta(
      "refresh_token_expires_at",
      payload.refresh_token_expires_at || ""
    );
    this.setMeta("client_type", payload.client_type || this.getClientType());
    this.setMeta("auth_version", payload.auth_version || "");
    this.setMeta("read_only", payload.read_only === true ? "true" : "");

    logger.auth("auth.saved", {
      hasAccessToken: !!accessToken,
      hasRefreshToken: !!(payload.refresh_token || this.getRefreshToken()),
      accessTokenExpiresAt: payload.access_token_expires_at || "",
      refreshTokenExpiresAt: payload.refresh_token_expires_at || "",
    });

    return accessToken;
  }

  getAccessToken() {
    return this.getToken();
  }

  getRefreshToken() {
    return this.getMeta("refresh_token");
  }

  getAccessTokenExpiresAt() {
    return this.getMeta("access_token_expires_at");
  }

  getRefreshTokenExpiresAt() {
    return this.getMeta("refresh_token_expires_at");
  }

  hasRefreshToken() {
    return !!this.getRefreshToken();
  }

  isV2Session() {
    return this.hasRefreshToken() || this.getMeta("auth_version") == "2";
  }

  isReadOnly() {
    return (
      this.getMeta("read_only") === "true" || this.getClientType() === "kiosk"
    );
  }

  getReadOnly() {
    return this.getMeta("read_only") === "true";
  }

  isAccessTokenExpiringSoon(bufferMs = 5 * 60 * 1000) {
    const expiresAt = this.getAccessTokenExpiresAt();
    if (!expiresAt) return false;

    return +new Date(expiresAt) - Date.now() <= bufferMs;
  }

  setClientType(type) {
    const clientType = ["browser", "mobile", "kiosk"].includes(type)
      ? type
      : "browser";
    localStorage.setItem("client_type", clientType);
    this.setMeta("client_type", clientType);
  }

  getClientType() {
    const stored =
      localStorage.getItem("client_type") || this.getMeta("client_type");
    if (["browser", "mobile", "kiosk"].includes(stored)) return stored;

    const envType = process.env.VUE_APP_CLIENT_TYPE;
    if (["browser", "mobile", "kiosk"].includes(envType)) return envType;

    return this.isMobileClient() ? "mobile" : "browser";
  }

  getDeviceId() {
    return localStorage.getItem("device_identification") || "";
  }

  getDeviceName() {
    const browser = this.detectBrowser();
    const platform = navigator.platform || "unknown platform";
    return `${browser} on ${platform}`;
  }

  getDeviceMetadata() {
    return {
      client_type: this.getClientType(),
      device_id: this.getDeviceId(),
      device_name: this.getDeviceName(),
    };
  }

  clearAuthState(reason = "unknown", meta = {}) {
    logger.auth("auth.clear_state", {
      reason,
      ...meta,
    });
    this.do();
    [
      "refresh_token",
      "access_token_expires_at",
      "refresh_token_expires_at",
      "auth_version",
      "read_only",
      "ws_token",
      "ws_token_expires_at",
    ].forEach((key) => this.removeMeta(key));
  }

  setMeta(key, value) {
    if (value === undefined || value === null || value === "") {
      this.removeMeta(key);
      return;
    }

    localStorage.setItem(this.metaPrefix + key, value);
  }

  getMeta(key) {
    return localStorage.getItem(this.metaPrefix + key) || "";
  }

  removeMeta(key) {
    localStorage.removeItem(this.metaPrefix + key);
  }

  do() {
    // const r = ["lang"];
    let td = [];
    for (let i = 0; i < localStorage.length; i++) {
      let k = localStorage.key(i);
      let ko = k.split("_");
      ko = ko[ko.length - 1];
      if (this.z.includes(ko)) {
        td.push(k);
      }
      if (k.endsWith("-name")) {
        td.push(k);
      }
    }
    for (const k of td) {
      localStorage.removeItem(k);
    }
  }

  getToken() {
    let d = {};
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k.includes("_")) {
        const v = localStorage.getItem(k);
        let ok = k.split("_");
        ok = ok[ok.length - 1];
        const o = this.z.indexOf(ok);
        if (o >= 0) {
          d[k] = [o, v];
        }
      }
    }
    if (Object.keys(d).length < 8) return false;
    let st = [];
    const dv = Object.values(d);
    for (let i = 0; i < dv.length; i++) {
      st[i] = "";
    }
    dv.forEach((dv) => {
      st[dv[0]] = dv[1];
    });
    return htu(st.join(""));
  }

  // get splitted token
  gst(t, l = 8) {
    let c = 0;
    let a = [];
    const vl = Math.ceil(t.length / l);
    // console.log("value length", vl);
    for (let i = 0; i < t.length; i++) {
      if (a[c] && a[c].length === vl) c++;
      if (!a[c]) a[c] = "";
      a[c] += t[i].toString();
    }
    return a;
  }

  mkv(k, v) {
    let m = {};
    for (let i = 0; i < v.length; i++) {
      m[k[i]] = v[i];
    }
    return m;
  }

  stls(d) {
    shA(Object.entries(d)).forEach((a) => {
      localStorage.setItem(a[0], a[1]);
    });
  }

  gk(l = 8) {
    let k = [];
    let os = shA(this.s);
    for (let i = 0; i < l; i++) {
      k[i] = os[i] + "_" + this.z[i];
    }
    return k;
  }

  logged() {
    return this.getToken() ? true : false;
  }

  logout(reason = "logout_called") {
    // console.log("im here");
    logger.auth("auth.logout_called", {
      reason,
    });
    this.clearAuthState(reason);
  }

  isMobileClient() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  detectBrowser() {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (
      navigator.userAgent.indexOf("MSIE") != -1 ||
      !!document.documentMode == true
    ) {
      return "IE";
    }

    return "Unknown";
  }
}

export default new Auth();

function uth(s) {
  return Array.from(s)
    .map((c) =>
      c.charCodeAt(0) < 128
        ? c.charCodeAt(0).toString(16)
        : encodeURIComponent(c).replace(/%/g, "").toLowerCase()
    )
    .join("");
}
function htu(hex) {
  return decodeURIComponent("%" + hex.match(/.{1,2}/g).join("%"));
}

const shA = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = a[i];
    a[i] = a[j];
    a[j] = t;
  }
  return a;
};
